import { create } from 'zustand';
const useAuthStore = create((set) => ({
  token: localStorage.getItem('lf_token'),
  user: JSON.parse(localStorage.getItem('lf_user') || 'null'),
  setAuth: (token, user) => {
    localStorage.setItem('lf_token', token);
    localStorage.setItem('lf_user', JSON.stringify(user));
    set({ token, user });
  },
  logout: () => {
    localStorage.removeItem('lf_token');
    localStorage.removeItem('lf_user');
    set({ token: null, user: null });
  },
}));
export default useAuthStore;
